
import isMobile from 'ismobilejs';
import actions from './actions';


const sm = 600;
const md = 900;
const lg = 1200;
const xl = 1536;


function getScreenSize() {
   const height = window.innerHeight;
   const width = window.innerWidth;

   let size;

   if (width < sm) {
      size = "xs";
   } else if (width < md) {
      size = "sm"
   } else if (width < lg) {
      size = "md"
   } else if (width < xl) {
      size = "lg"
   } else {
      size = "xl"
   }


   const orientation = width > height ? "landscape" : "portrait"

   return {
      width,
      height,
      size,
      orientation
   }
}

function updateDeviceInfo() {
   const deviceInfo = isMobile();
   const { size, width, height, orientation } = getScreenSize();

   let type;

   if (deviceInfo.tablet)
      type ="tablet"
   else if (deviceInfo.phone)
      type =  "phone";
   else
      type = "other";

   const mobile = deviceInfo.phone || deviceInfo.tablet;

   actions.setDeviceInfo({
      width,
      height,
      size,
      type,
      mobile,
      orientation,
   });
   
}


function init() {
   window.removeEventListener("resize", updateDeviceInfo); // just in case this function is called more than once
   window.addEventListener("resize", updateDeviceInfo);
   updateDeviceInfo();
}

export {
   init
}